package com.daytimegaming.ourdailyfinances.domain.model

data class PlaidItem(
    val itemId: String,
    val institutionName: String,
    val createdAt: String,
    val balancesLastSyncedAt: String? = null,
    val transactionsLastSyncedAt: String? = null,
    val recurringLastSyncedAt: String? = null,
    val investmentsLastSyncedAt: String? = null,
    val loginRequired: Boolean = false,
    val updateRequired: Boolean = false,
    val subscriptionRequired: Boolean = false,
)
